import React, { useState } from "react";
import SectionHeader from "../../../../Components/SectionHeader";
import TestimonialCard from "../../../Home/Sections/Testimonials/Components/TestimonialCard";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { testimonials } from "../../../../TestimonialsData";

const OfferingTestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );
  };

  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  // Minimum swipe distance (50px)
  const minSwipeDistance = 50;

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
    setTouchEnd(e.targetTouches[0].clientX); // Needed for vertical scroll prevention
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);

    // Prevent vertical scrolling when horizontal swipe
    if (Math.abs(touchStart - touchEnd) > 10) {
      e.preventDefault();
    }
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) nextTestimonial();
    if (isRightSwipe) prevTestimonial();

    // Reset values
    setTouchStart(0);
    setTouchEnd(0);
  };

  return (
    <section className="relative flex flex-col items-center pt-[8%] pb-[22%]">
      <SectionHeader
        tagline="AI In Actions"
        title="See what our clients say about us"
      />
      <div className="relative w-full">
        <div className="relative flex flex-col justify-center">
          {/* Navigation Buttons with responsive positioning */}
          <button
            onClick={prevTestimonial}
            aria-label="Previous testimonial"
            className="hidden md:flex absolute left-0 md:left-10 top-1/3 -translate-y-1/2 translate-x-1/4 md:translate-x-2/1 w-14 h-14 items-center justify-center rounded-full bg-black shadow-[0_0_15px_rgba(255,255,255,0.3)] hover:shadow-[0_0_25px_rgba(255,255,255,0.5)] transition-all z-10"
          >
            <ChevronLeft size={24} className="text-white" />
          </button>
          <button
            onClick={nextTestimonial}
            aria-label="Next testimonial"
            className="hidden md:flex absolute right-0 md:right-10 top-1/3 -translate-y-1/2 -translate-x-1/4 md:-translate-x-2/1 w-14 h-14 items-center justify-center rounded-full bg-black shadow-[0_0_15px_rgba(255,255,255,0.3)] hover:shadow-[0_0_25px_rgba(255,255,255,0.5)] transition-all z-10"
          >
            <ChevronRight size={24} className="text-white" />
          </button>

          {/* Swipeable Content Area */}
          <div
            className="min-h-[300px] flex items-center transition-all duration-300 ease-in-out px-[10%] md:px-[10%]"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
            <TestimonialCard
              quote={testimonials[currentIndex].quote}
              author={testimonials[currentIndex].author}
              authorProfilePic={testimonials[currentIndex].authorProfilePic}
              role={testimonials[currentIndex].role}
            />
          </div>

          {/* Content Container with fixed dimensions */}
          {/* <div className="min-h-[300px] flex items-center transition-all duration-300 ease-in-out px-[10%] md:px-[10%]">
              <TestimonialCard
                quote={testimonials[currentIndex].quote}
                author={testimonials[currentIndex].author}
                authorProfilePic={testimonials[currentIndex].authorProfilePic}
                role={testimonials[currentIndex].role}
              />
            </div> */}

          {/* Mobile pagination indicators */}
          {/* flex */}
          <div className="hidden justify-center space-x-2 mt-8 md:hidden">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-3 h-3 rounded-full transition-all ${
                  index === currentIndex
                    ? "bg-white"
                    : "bg-white/30 hover:bg-white/50"
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
          <div className="md:hidden flex flex-row items-center justify-center space-x-4 mt-10">
            <button
              onClick={prevTestimonial}
              aria-label="Previous testimonial"
              className="flex w-14 h-14 items-center justify-center rounded-full bg-black shadow-[0_0_15px_rgba(255,255,255,0.3)] transition-all z-10"
            >
              <ChevronLeft size={24} className="text-white" />
            </button>
            <button
              onClick={nextTestimonial}
              aria-label="Next testimonial"
              className="flex w-14 h-14 items-center justify-center rounded-full bg-black shadow-[0_0_15px_rgba(255,255,255,0.3)] transition-all z-10"
            >
              <ChevronRight size={24} className="text-white" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OfferingTestimonialsSection;
